import { render, staticRenderFns } from "./MutualRecommendationWidgetWrapper.vue?vue&type=template&id=e8f89768"
import script from "./MutualRecommendationWidgetWrapper.vue?vue&type=script&lang=js"
export * from "./MutualRecommendationWidgetWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RecoSkeleton: require('/skade-pwa/components/ui/atom/skeleton/RecoSkeleton.vue').default})
